export default __webpack_public_path__ + "static/media/authentication.c9e4c516.png";